import { useState } from 'react';

import { useIsMounted } from '../hooks';

import English from './english';
import ELanguages from './types';

const initialValue = English;

const language = ELanguages.ENGLISH;

export default function useLocale() {
  const [locale, setLocale] = useState(initialValue);

  useIsMounted(() => {
    if (language === ELanguages.ENGLISH) setLocale(English);
  });

  return locale;
}
